import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../js/AuthContext';
import "../css/healthCheck.css";
import { IoPersonCircle } from "react-icons/io5";
import { RiLogoutBoxLine } from "react-icons/ri";
import { FaFileUpload } from "react-icons/fa";
import { IoHomeOutline } from "react-icons/io5";
import { BsLightning } from "react-icons/bs";
import { GiSnail } from "react-icons/gi";
import { VscGraph } from "react-icons/vsc";
import { FaCircle } from "react-icons/fa";
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';

import { Bar } from 'react-chartjs-2';
import { Scatter } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const organizations = [
  'Org1MSP',
  'Org2MSP',
  'Org3MSP',
  'Org4MSP',
  'Org5MSP'
];


const HealthCheck = () => {
  const [activePage, setActivePage] = useState(1);
  const totalSets = 2;

  const [healthCheckStatus, setHealthCheckStatus] = useState('');
  const [modelsFast, setModelsFast] = useState('');
  const [modelsSlow, setModelsSlow] = useState('');
  const [metricsFast, setMetricsFast] = useState([]);
  const [metricsSlow, setMetricsSlow] = useState('');
  const [allModelsFast, setAllModelsFast] = useState([]);
  const [allModelsSlow, setAllModelsSlow] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('Org1MSP');
  const [fileHash, setFileHash] = useState('');
  const [data, setData] = useState({ error: null });
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef(null);
  const { userEmail, logout } = useAuth();
  const [displayText, setDisplayText] = useState('Home');
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [quickMetricsData, setQuickMetricsData] = useState([]);
  const excludedSha = ['sha256-example2', 'sha256-example3', 'sha256-example1'];

  useEffect(() => {
    <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"></meta>
    const fetchData = async () => {
      const apiKey = 'your-api-key-here';
      const apiUrl = 'https://api-gateway-green-hf-service.hi-iberia.es';

      // Health Check
      try {
        const response = await axios.get(apiUrl + '/health', {
          headers: { 'api-key': apiKey },
        });
        setHealthCheckStatus(response.data.status);
      } catch (err) {
        console.error('Error en Health Check:', err);
      }

      // Buscar modelos
      try {
        const response = await axios.get(`${apiUrl}/models`);
        setModels(response.data);
        setFilteredModels(response.data);
      } catch (error) {
        console.error('Error fetching models', error);
      }

      // Últimos modelos rápidos
      try {
        const responseModelFast = await axios.get(apiUrl + '/rapidas/models/latest?orgMsp=Org1MSP', {
          headers: { 'api-key': apiKey },
        });
        setModelsFast(formatResponse(responseModelFast.data));
      } catch (err) {
        console.error('Error al obtener los últimos modelos (rápidas)', err);
      }

      // Últimos modelos lentas
      try {
        const responseModelSlow = await axios.get(apiUrl + '/lentas/models/latest?orgMsp=Org1MSP', {
          headers: { 'api-key': apiKey },
        });
        setModelsSlow(formatResponse(responseModelSlow.data));
      } catch (err) {
        console.error('Error al obtener los últimos modelos (lentas)', err);
      }

      // Modelo específico rápidas
      try {
        const responseMetricsFast = await axios.get(apiUrl + '/rapidas/metrics/Org1MSP/sha256-model1', {
          headers: { 'api-key': apiKey },
        });
        const formattedData = formatResponse(responseMetricsFast.data) || [];
        setMetricsFast(formattedData);
      } catch (err) {
        console.error('Error al obtener los modelos específicos de rápidas', err);
      }

      // Modelo específico lentas
      try {
        const responseMetricsSlow = await axios.get(apiUrl + '/lentas/metrics/Org2MSP/sha256-model2', {
          headers: { 'api-key': apiKey },
        });
        setMetricsSlow(formatResponse(responseMetricsSlow.data.metrics));
      } catch (err) {
        console.error('Error al obtener los modelos específicos lentas', err);
      }

      // Todos los modelos con sus métricas (rápidas)
      try {
        const responseAllModelFast = await axios.get(apiUrl + '/rapidas/models/with-metrics?orgMsp=Org1MSP', {
          headers: { 'api-key': apiKey },
        });
        const metricsData = responseAllModelFast.data.modelsWithMetrics || [];
        setAllModelsFast(metricsData); 
      } catch (err) {
        console.error('Error al obtener todos los modelos con sus métricas rápidas', err);
      }

      // Todos los modelos con sus métricas (lentas)
      try {
        const responseAllModelSlow = await axios.get(apiUrl + '/lentas/models/with-metrics?orgMsp=Org1MSP', {
          headers: { 'api-key': apiKey },
        });
        const metricsData = responseAllModelSlow.data.modelsWithMetrics || [];
        setAllModelsSlow(metricsData); 
      } catch (err) {
        console.error('Error al obtener todos los modelos con sus métricas lentas', err);
      }
    };

    fetchData();
  }, []);

  const formatResponse = (data) => {
    return Array.isArray(data) ? data : [data];
  };

  const handleNextPage = () => {
    setActivePage((prevPage) => Math.min(prevPage + 1, totalSets));
  };

  const handlePrevPage = () => {
    setActivePage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    if (e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];
      setFile(droppedFile);
      calculateFileHash(droppedFile);
      toast.success('Archivo añadido correctamente'); 
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      calculateFileHash(selectedFile); 
      toast.success('Archivo añadido correctamente'); 
    }
  };

  const handleFileClick = () => {
    fileInputRef.current.click(); 
  };

  const calculateFileHash = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const binary = e.target.result;
      const wordArray = CryptoJS.lib.WordArray.create(binary);
      const hash = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex); 
      setFileHash(hash); 
      console.log(`Hash SHA-256 del archivo: ${hash}`);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error('Por favor, añada un archivo antes de enviar.');
      return;
    }

    if (!fileHash) {
      toast.error('No se pudo calcular el archivo hash');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    const apiKey = 'your-api-key-here';
    const apiUrl = 'https://api-gateway-green-hf-service.hi-iberia.es';
    try {
      const isRapidas = selectedOrg.includes('Org1MSP');
      const endpoint = isRapidas ? '/rapidas/models' : '/lentas/models';
      const sha = isRapidas ? 'sha256-model1' : 'sha256-model2';
      const url = isRapidas ? 'https://example.com/model1' : 'https://example.com/model2';

      const data = {
        orgMsp: selectedOrg,
        sha,
        url
      };

      await axios.post(`${apiUrl}${endpoint}`, data, {
        headers: {
          'Content-Type': 'application/json',
          'api-key': apiKey,
        },
      });

      toast.success('Archivo enviado con éxito');
    } catch (error) {
      console.error('Error al enviar el archivo:', error);
      toast.error('Error al enviar el archivo');
    }
  };

  const handleButtonClick = (content) => {
    setDisplayText(content);
    setSelectedOrg(''); 
    setSearchTerm('');
  };

  const maeData = [...allModelsFast, ...allModelsSlow].flatMap(model =>
    model.metrics.filter(metric => metric.metricType === 'MAE' && !isNaN(parseFloat(metric.metricValue)))
      .map(metric => ({
        x: parseFloat(metric.metricValue),
        y: 1,
      }))
  );
  
  const rmseData = [...allModelsFast, ...allModelsSlow].flatMap(model =>
    model.metrics.filter(metric => metric.metricType === 'RMSE' && !isNaN(parseFloat(metric.metricValue)))
      .map(metric => ({
        x: parseFloat(metric.metricValue),
        y: 2,
      }))
  );

  const filteredOrganizations = organizations.filter(org => 
    org.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const filteredMetric = metricsFast.filter(metric => !selectedOrg || metric.orgName === selectedOrg);
    const chartData = filteredMetric.map(metric => ({
      x: parseFloat(metric.metricValue), 
      y: parseFloat(metric.metricValue), 
      metricType: metric.metricType,      
      orgName: metric.orgName,
  }));

    setQuickMetricsData(chartData);
}, [metricsFast, selectedOrg]);

  const renderSetContent = (pageNumber) => {
    switch (pageNumber) {
      case 1:
        return (
          <div className="container">
          <div className="header">
            <h3>Información de la Red</h3>
            <div className="subheader-container">
              <div className="subheader-item health-check">Health Check Status</div>
              <div className="subheader-item up">
                <FaCircle className='circle-icon' />
                <div className='health-check-status'>{healthCheckStatus.includes('UP') ? 'UP' : healthCheckStatus.includes('DOWN') ? 'DOWN' : ''}</div>
              </div>
            </div>
          </div>

          <div className="main-content parent">
            <div className="left-column">
              <div className="div1">
                <button className="card" onClick={() => handleButtonClick('Home')}><IoHomeOutline className="icon" /> Home</button>
              </div>
              <div className="div2">
                <button className="card" onClick={() => handleButtonClick('Fast Charging')}><BsLightning className="icon" /> Fast Charging</button>
              </div>
              <div className="div3">
                <button className="card" onClick={() => handleButtonClick('Slow Charging')}><GiSnail className="icon" /> Slow Charging</button>
              </div>
              <div className="div4">
                <button className="card" onClick={() => handleButtonClick('Metrics')}><VscGraph className="icon" /> Metrics</button>
              </div>
            </div>
            <div className="menu-dropdown">
              <select onChange={(e) => handleButtonClick(e.target.value)}>
                <option value="Home">Home</option>
                <option value="Fast Charging">Fast Charging</option>
                <option value="Slow Charging">Slow Charging</option>
                <option value="Metrics">Metrics</option>
              </select>
            </div>

          <div className="right-column">
          {displayText === 'Home' && (
            <div className="home-content">
              <div className="rectangles-container">
                <div className="green-box">
                  <p className="model-title">Mejor Modelo</p>
                  <p className="model-detail">SHA: sha256-model1</p>
                  <p className="model-detail">Accuracy: 0.95</p>
                  <p className="model-detail">F1 Score: 0.92</p>
                </div>
                <div className="yellow-box">
                  <p className="model-title">Total de Modelos Enviados</p>
                  <p className="model-detail">Rápidos: {allModelsFast.length}</p>
                  <p className="model-detail">Lentos: {allModelsSlow.length}</p>
                </div>
              </div>
              <h4 className="metrics-title">Correlación de métricas por modelo (SHA)</h4>
              <div className="charts-container">
                {metricsFast.map((model, index) => (
                  <div key={index} className="chart-box">
                    <Bar 
                      data={{
                        labels: ['Accuracy', 'F1 Score'],
                        datasets: [{
                          label: model.sha,
                          data: [parseFloat(model.metricValue), Math.random()],
                          backgroundColor: ['rgba(75, 192, 192, 0.2)', 'rgba(255, 99, 132, 0.2)'],
                          borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 99, 132, 1)'],
                          borderWidth: 1,
                        }],
                      }}
                      options={{ responsive: true, scales: { y: { beginAtZero: true } } }}
                    />
                    <p className="chart-title">{model.sha}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {displayText === 'Fast Charging' && (
            <div className="fast-charging-content">
             <div className="controls-container">
              <div className="org-select-slow">
                <select
                  id="org-select"
                  value={selectedOrg}
                  onChange={(e) => setSelectedOrg(e.target.value)}
                >
                  <option value="" disabled>Selecciona una Organización</option>
                  {filteredOrganizations.map(org => (
                    <option key={org} value={org}>{org}</option>
                  ))}
                </select>
              </div>
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Buscar por SHA"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
              <div className='information-sha'>
                {allModelsFast && allModelsFast.length > 0 ? (
                  allModelsFast
                  .filter(item => 
                    (!selectedOrg || item.model.orgName === selectedOrg) && 
                    (!searchTerm || item.model.sha.includes(searchTerm)) &&
                    !excludedSha.includes(item.model.sha)
                  )
                    .map((item, index) => ( 
                      <div 
                        key={index} 
                        className="model-item" 
                        style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', position: 'relative', height: '40%', boxSizing: 'border-box' }}  
                      >
                        <div style={{ flex: 1, paddingRight: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}> 
                          <p style={{ margin: '0' }}><strong>Modelo {item.model.orgName}</strong></p>
                          <p className="sha"><strong>SHA:</strong> {item.model.sha}</p> 
                          <p className="sha" style={{ margin: '0', whiteSpace: 'normal' }}><strong>URL:</strong> {item.model.url}</p>             
                        </div>
                      </div>
                    ))
                ) : (
                  <p>No hay datos disponibles.</p>
                )}
              </div>
            </div>
          )}

          {displayText === 'Slow Charging' && (
            <div className="slow-charging-content">
             <div className="controls-container"> 
              <div className="org-select-slow">
                <select
                  id="org-select"
                  value={selectedOrg}
                  onChange={(e) => setSelectedOrg(e.target.value)}
                >
                  <option value="" disabled>Selecciona una Organización</option>
                  {filteredOrganizations.map(org => (
                    <option key={org} value={org}>{org}</option>
                  ))}
                </select>
              </div>
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Buscar por SHA"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
              <div className='information-sha'> 
                {allModelsSlow && allModelsSlow.length > 0 ? (
                  allModelsSlow
                  .filter(item => 
                    (!selectedOrg || item.model.orgName === selectedOrg) && 
                    (!searchTerm || item.model.sha.includes(searchTerm)) 
                   
                  )
                    .map((item, index) => ( 
                      <div 
                        key={index} 
                        className="model-item" 
                        style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', position: 'relative', height: '40%', boxSizing: 'border-box' }}
                      >
                        <div style={{ flex: 1, paddingRight: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}> 
                          <p style={{ margin: '0' }}><strong>Modelo {item.model.orgName}</strong></p>
                          <p className="sha"><strong>SHA:</strong> {item.model.sha}</p>        
                          <p className="sha" style={{ margin: '0', whiteSpace: 'normal' }}><strong>URL:</strong> {item.model.url}</p>   
                        </div>
                      </div>
                    ))
                ) : (
                  <p>No hay datos disponibles.</p>
                )}
              </div>
             
            </div>
          )}
         
         {displayText === 'Metrics' && (
          <div className="metrics-content">
            <div className="org-select">
              <div className="select-wrapper">
                <select
                  id="org-select"
                  value={selectedOrg}
                  onChange={(e) => setSelectedOrg(e.target.value)}
                >
                  <option value="" disabled>Selecciona una Organización</option>
                  {filteredOrganizations.map(org => (
                    <option key={org} value={org}>{org}</option>
                  ))}
                </select>
                <span className="icon-select">▼</span>
              </div>
            </div>

            <div className="metrics-container">
              <div className="metrics-left">
                <div style={{ overflowY: 'auto', height: '400px' }}>
                  {Array.isArray(allModelsFast) && Array.isArray(allModelsSlow) && 
                  (allModelsFast.length > 0 || allModelsSlow.length > 0) ? (
                    [...allModelsFast, ...allModelsSlow].flatMap(model =>
                      model.metrics.filter(metric => !selectedOrg || metric.orgName === selectedOrg)
                        .map((metric, index) => (
                          <div 
                            key={index} 
                            className="metric-item" 
                            style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              marginBottom: '10px', 
                              border: '1px solid #ccc', 
                              padding: '10px', 
                              borderRadius: '5px', 
                              position: 'relative', 
                              height: '30%', 
                              boxSizing: 'border-box'
                            }}
                          >
                            <div
                              style={{
                                width: '5px', 
                                height: '100%', 
                                backgroundColor: metric.metricType === 'MAE' ? 'rgba(75, 192, 192, 1)' : 
                                                metric.metricType === 'RMSE' ? 'rgba(255, 99, 132, 1)' : 'none', 
                              }}
                            ></div>
                            <div style={{ flex: 1, paddingLeft: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              <p style={{ margin: '0' }}><strong>Métrica: {metric.metricType}</strong></p>
                              <p style={{ margin: '0' }}>Valor: {parseFloat(metric.metricValue).toFixed(4)}</p>
                              <p style={{ margin: '0' }}>SHA: {metric.sha.slice(0, 10)}</p>
                              <p style={{ margin: '0' }}>Organización: {metric.orgName}</p>
                            </div>
                          </div>
                        ))
                    )
                  ) : (
                    <p>No hay datos disponibles.</p>
                  )}
                </div>
              </div>
              <div className="metrics-chart">
                <h4>Gráfico de Métricas</h4>
                <Scatter
                  data={{
                    datasets: [
                      {
                        label: 'MAE',
                        data: maeData,
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 1,
                        radius: 5,
                      },
                      {
                        label: 'RMSE',
                        data: rmseData,
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 1,
                        radius: 5,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    scales: {
                      x: {
                        type: 'linear',
                        position: 'bottom',
                        title: {
                          display: true,
                          text: 'Valor de Métrica',
                        },
                        
                      },
                      y: {
                        beginAtZero: true,
                        title: {
                          display: true,
                          text: 'Tipo de Métrica',
                        },
                        min: 0.9, 
                        max: 3,
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
        </div>
        </div>
        </div>    
      );
      case 2:
        return (
          <div className="container2Divs-bc">
            <div className="header">
              <h2 className='titulo-cabecera'>Subida de Modelos</h2>
            </div>
            <div className="left-column-modelos">
              <h3 className='nombre-organizacion'>Nombre Organización: {selectedOrg}</h3>
              <select className="input-field" value={selectedOrg} onChange={(e) => setSelectedOrg(e.target.value)}>
                <option value="Org1MSP">Org1MSP</option>
                <option value="Org2MSP">Org2MSP</option>
                <option value="Org3MSP">Org3MSP</option>
                <option value="Org4MSP">Org4MSP</option>
                <option value="Org5MSP">Org5MSP</option>
              </select>

              <h3 className='nombre'>SHA del modelo</h3>
              <div
                className={`file-drop-zone ${dragging ? 'dragging' : ''}`}
                onDrop={handleDrop}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onClick={handleFileClick}
                onDragOver={(e) => e.preventDefault()}
              >
                <FaFileUpload className="file-icon" />
                {file ? (
                  <p>{file.name}</p>
                ) : (
                  <p>Arrastra y suelta el archivo aquí o haz clic para seleccionar</p>
                )}
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </div>
              <p className="download-text">
                Descargar Ejemplo de <a href="ModeloPesos.pth" download>Pesos de Modelo</a> para la prueba
              </p>
              <button onClick={handleSubmit} className='enviar'>Enviar</button>
            </div>
            <div className="right-column">
              <img src="app/esquema.jpg" alt="Red de Blockchain" className="right-image" />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
       <button
        className={`scroll-btn left ${activePage === 1 ? "disabled" : ""}`}
        onClick={activePage > 1 ? handlePrevPage : null}
      >
        {"<"}
      </button>
      <button
        className={`scroll-btn right ${activePage === totalSets ? "disabled" : ""}`}
        onClick={activePage < totalSets ? handleNextPage : null}
      >
        {">"}
      </button>
      {renderSetContent(activePage)}
      <div className="welcome-screen">
        <button onClick={logout} className='cerrar-sesion'>
          <RiLogoutBoxLine /> 
          <span>Cerrar sesión</span>
        </button>
      </div>
      <div className="logos-container-hc">
        <img src="app/ue-color.png" alt="Union" className="logo-hc" />
        <img src="app/ministerio-color.png" alt="Ministerio" className="logo-hc" />
        <img src="app/plan_recuperacion_color.png" alt="Recuperacion" className="logo-hc" />
      </div>
    </div>
  );
};

export default HealthCheck;
